import {createInitAjaxFormMap} from "./index";
import {createGoogleMap as createMap, getApi, loadGoogleMapsAPI} from '../google-map';

export function apiLoaded(){
    return loadGoogleMapsAPI();
}

export const initAjaxFormMap = createInitAjaxFormMap({createMap, getApi});